import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/instalar-certificado-ssl.svg'


const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "breadcrumb-wrapper pt-3" }
const _hoisted_3 = { class: "row pt-5 px-3" }
const _hoisted_4 = { class: "col-12 col-lg-6" }
const _hoisted_5 = { class: "w-100 d-flex justify-content-start mb-3" }
const _hoisted_6 = { class: "pb-3" }
const _hoisted_7 = { class: "d-flex justify-content-end pt-4" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "pt-4" }
const _hoisted_10 = { class: "pt-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_breadcrumb = _resolveComponent("breadcrumb")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_input_component = _resolveComponent("input-component")!
  const _component_icon_component = _resolveComponent("icon-component")!
  const _component_card_container = _resolveComponent("card-container")!
  const _component_contact = _resolveComponent("contact")!
  const _component_modal_mobile_warning = _resolveComponent("modal-mobile-warning")!
  const _component_modal_emission_steps = _resolveComponent("modal-emission-steps")!
  const _component_modal_download_certificate = _resolveComponent("modal-download-certificate")!
  const _component_modal_plugin_download = _resolveComponent("modal-plugin-download")!
  const _component_modal_different_computer_error = _resolveComponent("modal-different-computer-error")!
  const _component_modal_request_in_progress = _resolveComponent("modal-request-in-progress")!
  const _component_modal_wrong_credentials_sis_ar = _resolveComponent("modal-wrong-credentials-sis-ar")!
  const _component_modal_try_again = _resolveComponent("modal-try-again")!
  const _component_modal_plugin_confirmation = _resolveComponent("modal-plugin-confirmation")!
  const _component_modal_java = _resolveComponent("modal-java")!
  const _component_modal_plugin_download_confirmation = _resolveComponent("modal-plugin-download-confirmation")!
  const _component_modal_plugin_execution_confirmation = _resolveComponent("modal-plugin-execution-confirmation")!
  const _component_modal_plugin_not_executing = _resolveComponent("modal-plugin-not-executing")!
  const _component_modal_plugin_certificate_password = _resolveComponent("modal-plugin-certificate-password")!
  const _component_modal_set_new_password = _resolveComponent("modal-set-new-password")!
  const _component_modaol_onboarding_video = _resolveComponent("modaol-onboarding-video")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_component_breadcrumb, { "path-list": $setup.pathList }, null, 8, ["path-list"])
    ]),
    _cache[19] || (_cache[19] = _createElementVNode("section", { class: "page-title-wrapper text-start pt-4" }, [
      _createElementVNode("h2", { class: "fw-600" }, "Instalação em computador")
    ], -1)),
    _createElementVNode("section", _hoisted_3, [
      _cache[17] || (_cache[17] = _createElementVNode("div", { class: "col-md-6 d-none d-lg-block" }, [
        _createElementVNode("img", {
          alt: "emitir-certificado",
          src: _imports_0
        })
      ], -1)),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            id: "news-button",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.showOnboardingVideoModal && $setup.showOnboardingVideoModal(...args)))
          }, [
            _cache[11] || (_cache[11] = _createElementVNode("span", { class: "me-2" }, "Veja a novidade", -1)),
            _createVNode(_component_font_awesome_icon, { icon: ['fab', 'youtube'] })
          ])
        ]),
        _cache[15] || (_cache[15] = _createElementVNode("p", { class: "fs-6 text-start" }, " Para prosseguir com a instalação do seu Certificado Digital, insira seu usuário e senha de emissão. ", -1)),
        _createElementVNode("div", _hoisted_6, [
          _cache[12] || (_cache[12] = _createElementVNode("div", { class: "d-flex justify-content-start align-items-center pb-2" }, [
            _createElementVNode("span", { class: "fs-6 pe-2" }, "Usuário *")
          ], -1)),
          _createVNode(_component_input_component, {
            modelValue: $setup.userData.username,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.userData.username) = $event)),
            icon: "user",
            type: "text",
            placeholder: "Exemplo: 00ED000000 000000000",
            "error-log": $setup.userError,
            onFocused: _cache[2] || (_cache[2] = ($event: any) => ($setup.userNameIsBeingEdited = true)),
            onBlured: _cache[3] || (_cache[3] = ($event: any) => ($setup.userNameIsBeingEdited = false))
          }, null, 8, ["modelValue", "error-log"])
        ]),
        _createElementVNode("div", null, [
          _cache[13] || (_cache[13] = _createElementVNode("div", { class: "d-flex justify-content-start align-items-center pb-2" }, [
            _createElementVNode("span", { class: "fs-6 pe-2" }, "Senha de emissão *")
          ], -1)),
          _createVNode(_component_input_component, {
            modelValue: $setup.userData.password,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.userData.password) = $event)),
            icon: "lock",
            type: "password",
            placeholder: "Digite sua senha aqui",
            "error-log": $setup.passError,
            onFocused: _cache[5] || (_cache[5] = ($event: any) => ($setup.passwordIsBeingEdited = true)),
            onBlured: _cache[6] || (_cache[6] = ($event: any) => ($setup.passwordIsBeingEdited = false))
          }, null, 8, ["modelValue", "error-log"])
        ]),
        _cache[16] || (_cache[16] = _createStaticVNode("<div id=\"faqAccordionUserName\" class=\"accordion mt-4\"><div class=\"accordion-item\"><div id=\"faqAccordionQuestionWhereIsUserName\" class=\"accordion-header\"><button class=\"accordion-button collapsed\" type=\"button\" data-bs-toggle=\"collapse\" data-bs-target=\"#faqAccordionAnswerWhereUsUserName\" aria-expanded=\"false\" aria-controls=\"faqAccordionAnswerWhereUsUserName\"> Onde encontro meu usuário? </button></div><div id=\"faqAccordionAnswerWhereUsUserName\" class=\"accordion-collapse collapse\" aria-labelledby=\"faqAccordionQuestionWhereIsUserName\" data-bs-parent=\"#faqAccordionUserName\"><div class=\"accordion-body\"><p class=\"text-start fs-6 m-0\"> Você pode encontrar seu usuário no seu <strong>e-mail</strong> com o assunto <strong>“Emissão de Certificado Digital APROVADA”</strong> ou no <strong>Documento Reservado</strong>. <br><br> A sequência é <strong>composta por letras, números e espaço</strong>. </p></div></div></div></div><div id=\"faqAccordionPassword\" class=\"accordion mt-4\"><div class=\"accordion-item\"><div id=\"faqAccordionQuestionWhatIsThePassword\" class=\"accordion-header\"><button class=\"accordion-button collapsed\" type=\"button\" data-bs-toggle=\"collapse\" data-bs-target=\"#faqAccordionAnswerWhatIsThePassword\" aria-expanded=\"false\" aria-controls=\"faqAccordionAnswerWhatIsThePassword\"> O que é a senha de emissão? </button></div><div id=\"faqAccordionAnswerWhatIsThePassword\" class=\"accordion-collapse collapse\" aria-labelledby=\"faqAccordionQuestionWhatIsThePassword\" data-bs-parent=\"#faqAccordionPassword\"><div class=\"accordion-body\"><p class=\"text-start fs-6 m-0\"><strong>É a senha criada por você</strong> no momento do <strong>preenchimento dos dados</strong> do seu Certificado Digital. </p></div></div></div></div>", 2)),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            id: "next-step-button",
            disabled: !$setup.isAbleToContinue,
            class: _normalizeClass(["btn btn-primary", [$setup.isAbleToContinue ? 'btn-primary' : 'btn-secondary']]),
            onClick: _cache[7] || (_cache[7] = () => $setup.debouncedIssueCertificate())
          }, [
            _cache[14] || (_cache[14] = _createTextVNode(" Avançar ")),
            _createVNode(_component_icon_component, { name: "arrow-right" })
          ], 10, _hoisted_8)
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_9, [
      _createVNode(_component_card_container, null, {
        default: _withCtx(() => [
          _cache[18] || (_cache[18] = _createElementVNode("span", null, "Não conseguiu instalar o Certificado Digital?", -1)),
          _createElementVNode("span", {
            class: "link",
            onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.modalJava?.show())),
            onKeydown: _cache[9] || (_cache[9] = ($event: any) => ($setup.modalJava?.show()))
          }, "Clique aqui", 32)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("section", _hoisted_10, [
      _createVNode(_component_contact)
    ]),
    _createVNode(_component_modal_mobile_warning, { ref: "modalMobileWarning" }, null, 512),
    _createVNode(_component_modal_emission_steps, { ref: "emissionStepsModal" }, null, 512),
    _createVNode(_component_modal_download_certificate, { ref: "downloadCertificateModal" }, null, 512),
    _createVNode(_component_modal_plugin_download, { ref: "pluginDownloadModal" }, null, 512),
    _createVNode(_component_modal_different_computer_error, { ref: "differentComputerErrorModal" }, null, 512),
    _createVNode(_component_modal_request_in_progress, { ref: "requestInProgressModal" }, null, 512),
    _createVNode(_component_modal_wrong_credentials_sis_ar, { ref: "wrongCredentialsModal" }, null, 512),
    _createVNode(_component_modal_try_again, { ref: "tryAgainModal" }, null, 512),
    _createVNode(_component_modal_plugin_confirmation, {
      ref: "pluginConfimartionModal",
      onRetry: $setup.issueCertificate
    }, null, 8, ["onRetry"]),
    _createVNode(_component_modal_java, { ref: "modalJava" }, null, 512),
    _createVNode(_component_modal_plugin_download_confirmation, { ref: "pluginDownloadConfirmationModal" }, null, 512),
    _createVNode(_component_modal_plugin_execution_confirmation, {
      ref: "pluginExecutionConfirmation",
      onRetryCertificateIssuing: $setup.issueCertificate
    }, null, 8, ["onRetryCertificateIssuing"]),
    _createVNode(_component_modal_plugin_not_executing, { ref: "pluginNotExecutingModal" }, null, 512),
    _createVNode(_component_modal_plugin_certificate_password, {
      ref: "pluginCertificatePasswordModal",
      onChosePasswordConfirm: _cache[10] || (_cache[10] = () => $setup.proceed(''))
    }, null, 512),
    _createVNode(_component_modal_set_new_password, {
      ref: "setNewPasswordModal",
      onProceed: $setup.proceed
    }, null, 8, ["onProceed"]),
    _createVNode(_component_modaol_onboarding_video, { ref: "onboardingVideoModal" }, null, 512)
  ]))
}